import React from 'react';

import {
  createdAtMs,
  createdSlaTone,
  departureSlaTone,
  formatElapsed,
  formatUntilDeparture,
  scheduledDepartureMs,
} from './format';

const TONES = {
  green: { color: '#1B5E20', background: '#E8F5E9' },
  yellow: { color: '#F57F17', background: '#FFF8E1' },
  orange: { color: '#E65100', background: '#FFF3E0' },
  red: { color: '#C62828', background: '#FFEBEE' },
};

const Pill = ({ tone, label, title }) => {
  const colors = TONES[tone] || TONES.red;
  return (
    <span title={title} style={{ ...styles.pill, color: colors.color, background: colors.background }}>
      {label}
    </span>
  );
};

export const CreatedSla = ({ createdAt, now }) => {
  const at = createdAtMs(createdAt);
  if (at == null) return <span style={styles.muted}>—</span>;
  const elapsed = Math.max(0, now - at);
  return (
    <Pill
      tone={createdSlaTone(elapsed)}
      label={formatElapsed(elapsed)}
      title="Time since this request was created. Confirm within 48 hours."
    />
  );
};

export const DepartureSla = ({ flight, now }) => {
  const at = scheduledDepartureMs(flight);
  if (at == null) return <span style={styles.muted}>—</span>;
  const remaining = at - now;
  return (
    <Pill
      tone={departureSlaTone(remaining)}
      label={formatUntilDeparture(remaining)}
      title="Time until scheduled departure. Confirm at least 48 hours before."
    />
  );
};

const styles = {
  pill: {
    display: 'inline-block',
    fontSize: 13,
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    borderRadius: 4,
    padding: '3px 8px',
  },
  muted: {
    opacity: 0.4,
  },
};
